import { app } from '../../../app';

app.component('youAreNotCompanyAdmin', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    templateUrl: require('./you-are-not-company-admin.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/you-are-not-company-admin/you-are-not-company-admin.component.js